import { render } from "./MobileNav.vue?vue&type=template&id=b859963c"
import script from "./MobileNav.vue?vue&type=script&lang=js"
export * from "./MobileNav.vue?vue&type=script&lang=js"
script.render = render

export default script